<template>
  <v-row no-gutters>
    <v-file-input
      v-if="type === 'sub'"
      ref="uploadFile"
      class="d-none"
      v-model="subtitleUploadData.subtitleToBeUploaded"
      truncate-length="15"
      :accept="accept"
      :error="errors.wrongFormatFile"
      :disabled="loadings.subtitle"
      :messages="addFileErrorMsg"
      @change="handleFileInput"
    ></v-file-input>

    <v-file-input
      v-else
      ref="uploadFile"
      class="d-none"
      v-model="dubbingUploadData.dubbingToBeUploaded"
      truncate-length="15"
      :accept="accept"
      :error="errors.wrongFormatFile"
      :disabled="loadings.subtitle"
      :messages="addFileErrorMsg"
      @change="handleFileInput"
    ></v-file-input>
    <template v-if="subStage === 1">
      <v-row no-gutters>
        <v-col cols="12" class="text-center mb-6 mt-4">
          <span
            class="text-h7"
            :class="{ 'neutral--text': !$vuetify.theme.dark }"
            >{{ subtitle }}</span
          >
        </v-col>
        <v-col cols="12">
          <v-card
            class="v-card__dashed-border mx-8"
            :class="{ 'file-card--active': isDragging }"
            elevation="0"
            @click="handleSelectFile"
            @drop.prevent="handleDropFile"
            @dragover.prevent="onDragOver"
            @dragleave.prevent="onDragLeave"
          >
            <div class="d-flex flex-column my-12 py-12 text-center">
              <v-icon class="neutral--text text--lighten-2" size="64"
                >mdi-file-check-outline</v-icon
              >
              <span
                class="font-weight-medium upload-subtitle"
                :class="{
                  'neutral--text text--lighten-1': !$vuetify.theme.dark,
                }"
                >{{
                  $i18next.t(
                    'message.ai.dubbings.modal.upload.step_one.uploadCard.title'
                  )
                }}</span
              >
              <span class="primary--text">{{
                $i18next.t(
                  'message.ai.dubbings.modal.upload.step_one.uploadCard.subtitle'
                )
              }}</span>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-if="subStage === 2">
      <v-col cols="12" class="text-center mt-4">
        <span
          class="text-h7"
          :class="{
            'neutral--text': !$vuetify.theme.dark,
          }"
          >{{ subtitle }}</span
        >
      </v-col>
      <v-col
        cols="12"
        class="d-flex justify-center container__upload-list--modal"
      >
        <v-card elevation="0">
          <div class="subcontainer__upload-list--modal">
            <div
              class="d-flex align-center justify-space-between"
              v-for="(item, index) in toBeUploadedList"
              :key="`${item.name}--${index}`"
            >
              <div
                class="
                  d-flex
                  align-center
                  justify-space-between
                  f-width
                  list-item__bordered
                  py-3
                "
              >
                <div class="d-flex align-center">
                  <v-icon class="neutral--text text--lighten-2 mr-2"
                    >mdi-file</v-icon
                  >
                  <span
                    class="text-subtitle-1 text-truncate d-block"
                    :class="{
                      'neutral--text': !$vuetify.theme.dark,
                    }"
                    style="max-width: 280px"
                    :title="item.file.name"
                    >{{ item.file.name }}</span
                  >
                </div>
                <v-select
                  v-model="item.label"
                  class="v-input__custom-colorized v-select__lang"
                  outlined
                  hide-details
                  :placeholder="$t('message.pages.videoEditModal.language')"
                  item-text="label"
                  :value="item.label"
                  :menu-props="{ top: false, offsetY: true }"
                  :class="{
                    dark: $vuetify.theme.dark,
                  }"
                  :no-data-text="
                    $t('message.pages.videoEditModal.usedSubtitles')
                  "
                  :items="unusedLangCodes"
                  @change="handleUpdateSrcLang(index)"
                  dense
                >
                  <template #prepend-inner v-if="item.label">
                    <country-flag
                      :country="getCountryCodeBySrcLang(item.srclang)"
                    />
                  </template>
                  <template #append>
                    <v-icon> mdi-chevron-down </v-icon>
                  </template>
                </v-select>
              </div>
              <v-icon
                color="red"
                size="24"
                class="ml-3"
                @click="removeFromToBeUploadedList(index)"
                >mdi-close-circle</v-icon
              >
            </div>
          </div>
          <p
            class="mt-3 mb-0 primary--text font-weight-medium pointer"
            @click="handleSelectFile"
            @drop.prevent="handleDropFile"
            @dragover.prevent="handleDragOver"
          >
            {{
              $i18next.t(
                'message.ai.dubbings.modal.upload.step_two.subaActionBtn'
              )
            }}
          </p>
        </v-card>
      </v-col>
    </template>
    <template v-if="type === 'dub' && subStage === 3">
      <v-col cols="12" class="text-center mt-4">
        <span
          class="text-h7"
          :class="{ 'neutral--text': !$vuetify.theme.dark }"
          >{{
            $i18next.t('message.ai.dubbings.modal.upload.step_three.title')
          }}</span
        >
      </v-col>
      <v-col
        cols="12"
        class="d-flex justify-center container__upload-list--modal"
      >
        <v-card elevation="0">
          <div class="subcontainer__upload-list--modal">
            <div
              class="d-flex align-center justify-space-between"
              v-for="(item, index) in toBeUploadedList"
              :key="`${item.name}--${index}`"
            >
              <div
                class="
                  d-flex
                  align-center
                  justify-space-between
                  f-width
                  list-item__bordered
                  py-3
                "
              >
                <div class="d-flex align-center">
                  <v-icon v-if="item.completed" class="brand--text mr-2"
                    >mdi-file-check</v-icon
                  >
                  <v-icon class="neutral--text text--lighten-2 mr-2" v-else
                    >mdi-file</v-icon
                  >
                  <span
                    class="text-subtitle-1 text-truncate d-block"
                    :class="{
                      'neutral--text': !$vuetify.theme.dark,
                    }"
                    style="max-width: 280px"
                    :title="item.file.name"
                    >{{ item.file.name }}</span
                  >
                </div>
                <div class="d-flex align-center">
                  <span
                    v-if="item.progress"
                    class="text-caption danger--text mr-2"
                    :class="{
                      'neutral--text text--lighten-1': !item.error,
                    }"
                    >{{
                      calcMegabytes(
                        item.progress.bytesUploaded,
                        'B',
                        'MB',
                        true
                      )
                    }}
                    /
                    {{
                      calcMegabytes(item.progress.bytesTotal, 'B', 'MB', true)
                    }}</span
                  >
                  <template v-if="item.progress">
                    <v-progress-linear
                      v-if="!item.error"
                      class="v-progress-linear__custom-colorized"
                      v-model="item.progress.percentage"
                      color="primary"
                      height="16"
                    ></v-progress-linear>
                    <v-progress-linear
                      v-else
                      class="v-progress-linear__custom-colorized"
                      value="100"
                      color="danger"
                      striped
                      height="16"
                    ></v-progress-linear>
                  </template>
                  <template v-else>
                    <v-progress-linear
                      class="v-progress-linear__custom-colorized"
                      value="0"
                      color="primary"
                      height="16"
                    ></v-progress-linear>
                  </template>
                </div>
              </div>
            </div>

            <div
              class="d-flex px-3 py-2 align-center v-alert__error mt-6"
              v-if="hasProcessError"
            >
              <v-icon class="danger--text text--darken-1 mr-3" size="24px">
                mdi-close-octagon</v-icon
              >
              <span class="text-subtitle-2 danger--text text--darken-1">{{
                $i18next.t('message.ai.dubbings.modal.upload.uploadError')
              }}</span>
            </div>
          </div>
        </v-card>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import calcMegabytesMixin from '@/utils/calcMegabytes.js'
import { mapState, mapMutations } from 'vuex'
import CountryFlag from 'vue-country-flag'
import aiWorkflowMixin from '@/utils/aiWorkflow.mixin'

export default {
  name: 'UploadStage',
  components: {
    CountryFlag,
  },
  mixins: [calcMegabytesMixin, aiWorkflowMixin],
  props: {
    accept: {
      type: Array,
      default: () => ['.vtt', '.srt'],
    },
    subtitle: {
      type: String,
      default: 'Envie os arquivos de legenda (SRT ou VTT)',
    },
    unusedLangCodes: {
      type: Array,
      required: true,
    },
    subStage: {
      type: Number,
      default: 0,
    },
    loadings: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: 'sub',
    },
  },
  data: () => ({
    errors: {},
    isDragging: false,
  }),
  computed: {
    ...mapState({
      subtitleUploadData: (state) => state.video.subtitleData.upload,
      dubbingUploadData: (state) => state.video.dubbingData.upload,
    }),
    hasProcessError() {
      return Boolean(
        this.toBeUploadedList.filter((item) => item.error && !item.completed)
          .length
      )
    },
    toBeUploadedList() {
      let list = this.subtitleUploadData.subtitleListToBeUploaded
      if (this.type === 'dub') {
        list = this.dubbingUploadData.dubbingListToBeUploaded
      }
      return list
    },
    addFileErrorMsg() {
      if (this.errors.wrongFormatFile) {
        return this.$i18next.t(
          'message.pages.videoEditModal.errors.wrongFormatFile'
        )
      }
      return ''
    },
  },
  beforeDestroy() {
    this.RESET_SUBTITLE_DATA()
    this.RESET_DUBBING_DATA()
  },
  methods: {
    ...mapMutations('video', ['RESET_SUBTITLE_DATA', 'RESET_DUBBING_DATA']),
    handleSelectFile() {
      this.$refs.uploadFile.$el.querySelector('input').click()
    },
    removeFromToBeUploadedList(index) {
      let spliceList = this.subtitleUploadData.subtitleListToBeUploaded

      if (this.type === 'dub') {
        spliceList = this.dubbingUploadData.dubbingListToBeUploaded
      }

      spliceList.splice(index)
      if (!spliceList.length) this.$emit('changeSubStage', 1)
    },
    handleUpdateSrcLang(index) {
      let target = this.subtitleUploadData.subtitleListToBeUploaded[index]
      if (this.type === 'dub')
        target = this.dubbingUploadData.dubbingListToBeUploaded[index]
      target.srclang = this.langCodes.filter(
        ({ label }) => label === target.label
      )[0].srclang
    },
    clearErrors() {
      Object.keys(this.errors).forEach((e) => (this.errors[e] = false))
    },
    handleFileInput(file) {
      if (!(file instanceof File)) return
      this.clearErrors()
      let fileExtension =
        file?.name?.substring(
          file?.name?.lastIndexOf('.'),
          file?.name?.length
        ) || file?.name
      if (!this.accept.includes(fileExtension)) {
        this.errors.wrongFormatFile = true
        this.subtitleUploadData.subtitleToBeUploaded = null
        return
      }

      const handleFinishFileInput = {
        sub: this.handleInputSub,
        dub: this.handleInputDub,
      }
      handleFinishFileInput[this.type]()
      this.$refs.uploadFile.$el.querySelector('input').value = null
      this.$emit('changeSubStage', 2)
    },
    handleInputSub() {
      this.subtitleUploadData.subtitleListToBeUploaded.push({
        file: this.subtitleUploadData.subtitleToBeUploaded,
        srclang: this.unusedLangCodes[0].srclang,
        label: this.unusedLangCodes[0].label,
      })
      this.subtitleUploadData.subtitleToBeUploaded = null
    },
    handleInputDub() {
      this.dubbingUploadData.dubbingListToBeUploaded.push({
        file: this.dubbingUploadData.dubbingToBeUploaded,
        srclang: this.unusedLangCodes[0].srclang,
        label: this.unusedLangCodes[0].label,
      })
      this.dubbingUploadData.dubbingToBeUploaded = null
    },
    onDragOver(event) {
      event.currentTarget.classList.add('drag-over')
      this.isDragging = true
    },
    handleDropFile(event) {
      const files = event.dataTransfer.files
      const insertDropFile = {
        sub: (file) => {
          this.subtitleUploadData.subtitleToBeUploaded = file
        },
        dub: (file) => {
          this.dubbingUploadData.dubbingToBeUploaded = file
        },
      }
      if (files.length) {
        insertDropFile[this.type](files[0])
        this.handleFileInput(files[0])
      }
      this.isDragging = false
    },
    onDragLeave() {
      this.isDragging = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/_ai_works';
</style>

<style lang="scss" scoped>
.v-card {
  &__dashed-border {
    border: 2px dashed var(--v-neutral-lighten1);
    background: #f8f8ff;
  }
  transition: background-color 0.3s, border-color 0.3s;
}

.upload-subtitle {
  margin: 18px 0px 10px 0px;
  font-size: 18px;
}

.container__upload-list {
  &--modal {
    margin-top: 75px;

    > .v-card {
      width: 564px;
    }
  }
}

.v-select {
  &__lang {
    max-width: 200px;
  }
}

.not-allowed {
  cursor: not-allowed !important;
}

::v-deep .v-progress-linear {
  &__custom-colorized {
    width: 130px;
    border-radius: 4px;
    background: var(--v-neutral-lighten3);

    .v-progress-linear__determinate {
      border-radius: 4px;
    }

    .v-progress-linear__background {
      background: transparent;
      background-color: transparent !important;
    }
  }
}

.v-alert__error {
  background: var(--v-danger-base);
  border-radius: 4px;
}

.file-card--active {
  background-color: #3e50f729 !important;
  border: 2px solid var(--v-brand-base) !important;
}
</style>
